// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICarrierIdPropertyDto } from './ICarrierIdPropertyDto';
import {
    ICarrierIdPropertyDtoFromJSON,
    ICarrierIdPropertyDtoFromJSONTyped,
    ICarrierIdPropertyDtoToJSON,
    ICarrierIdPropertyDtoToJSONTyped,
} from './ICarrierIdPropertyDto';
import type { IEnrollmentMatrixLiteDto } from './IEnrollmentMatrixLiteDto';
import {
    IEnrollmentMatrixLiteDtoFromJSON,
    IEnrollmentMatrixLiteDtoFromJSONTyped,
    IEnrollmentMatrixLiteDtoToJSON,
    IEnrollmentMatrixLiteDtoToJSONTyped,
} from './IEnrollmentMatrixLiteDto';
import type { INamePropertyDto } from './INamePropertyDto';
import {
    INamePropertyDtoFromJSON,
    INamePropertyDtoFromJSONTyped,
    INamePropertyDtoToJSON,
    INamePropertyDtoToJSONTyped,
} from './INamePropertyDto';
import type { IDeductiblesByServiceTypePropertyDto } from './IDeductiblesByServiceTypePropertyDto';
import {
    IDeductiblesByServiceTypePropertyDtoFromJSON,
    IDeductiblesByServiceTypePropertyDtoFromJSONTyped,
    IDeductiblesByServiceTypePropertyDtoToJSON,
    IDeductiblesByServiceTypePropertyDtoToJSONTyped,
} from './IDeductiblesByServiceTypePropertyDto';
import type { IHealthPlanTypePropertyDto } from './IHealthPlanTypePropertyDto';
import {
    IHealthPlanTypePropertyDtoFromJSON,
    IHealthPlanTypePropertyDtoFromJSONTyped,
    IHealthPlanTypePropertyDtoToJSON,
    IHealthPlanTypePropertyDtoToJSONTyped,
} from './IHealthPlanTypePropertyDto';
import type { IPlanCategorySpendLimitDto } from './IPlanCategorySpendLimitDto';
import {
    IPlanCategorySpendLimitDtoFromJSON,
    IPlanCategorySpendLimitDtoFromJSONTyped,
    IPlanCategorySpendLimitDtoToJSON,
    IPlanCategorySpendLimitDtoToJSONTyped,
} from './IPlanCategorySpendLimitDto';
import type { IHealthPlanDeductibleConfigDto } from './IHealthPlanDeductibleConfigDto';
import {
    IHealthPlanDeductibleConfigDtoFromJSON,
    IHealthPlanDeductibleConfigDtoFromJSONTyped,
    IHealthPlanDeductibleConfigDtoToJSON,
    IHealthPlanDeductibleConfigDtoToJSONTyped,
} from './IHealthPlanDeductibleConfigDto';
import type { IIsAutoEnrollmentPropertyDto } from './IIsAutoEnrollmentPropertyDto';
import {
    IIsAutoEnrollmentPropertyDtoFromJSON,
    IIsAutoEnrollmentPropertyDtoFromJSONTyped,
    IIsAutoEnrollmentPropertyDtoToJSON,
    IIsAutoEnrollmentPropertyDtoToJSONTyped,
} from './IIsAutoEnrollmentPropertyDto';
import type { IPlanYearPlanDto } from './IPlanYearPlanDto';
import {
    IPlanYearPlanDtoFromJSON,
    IPlanYearPlanDtoFromJSONTyped,
    IPlanYearPlanDtoToJSON,
    IPlanYearPlanDtoToJSONTyped,
} from './IPlanYearPlanDto';
import type { IPlanYearLiteDto } from './IPlanYearLiteDto';
import {
    IPlanYearLiteDtoFromJSON,
    IPlanYearLiteDtoFromJSONTyped,
    IPlanYearLiteDtoToJSON,
    IPlanYearLiteDtoToJSONTyped,
} from './IPlanYearLiteDto';

/**
 * 
 * @export
 * @interface IHealthPlanDto
 */
export interface IHealthPlanDto {
    /**
     * 
     * @type {number}
     * @memberof IHealthPlanDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IHealthPlanDto
     */
    parent_id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IHealthPlanDto
     */
    is_plan?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanDto
     */
    plan_code?: string;
    /**
     * 
     * @type {INamePropertyDto}
     * @memberof IHealthPlanDto
     */
    name?: INamePropertyDto;
    /**
     * 
     * @type {IHealthPlanTypePropertyDto}
     * @memberof IHealthPlanDto
     */
    health_plan_types?: IHealthPlanTypePropertyDto;
    /**
     * 
     * @type {ICarrierIdPropertyDto}
     * @memberof IHealthPlanDto
     */
    carrier_id?: ICarrierIdPropertyDto;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanDto
     */
    plan_status?: IHealthPlanDtoPlanStatusEnum;
    /**
     * 
     * @type {IIsAutoEnrollmentPropertyDto}
     * @memberof IHealthPlanDto
     */
    is_auto_enrollment?: IIsAutoEnrollmentPropertyDto;
    /**
     * 
     * @type {IDeductiblesByServiceTypePropertyDto}
     * @memberof IHealthPlanDto
     */
    deductibles_by_service_type?: IDeductiblesByServiceTypePropertyDto;
    /**
     * 
     * @type {IPlanYearLiteDto}
     * @memberof IHealthPlanDto
     */
    plan_year?: IPlanYearLiteDto;
    /**
     * 
     * @type {Set<IHealthPlanDeductibleConfigDto>}
     * @memberof IHealthPlanDto
     */
    health_plan_deductible_configs?: Set<IHealthPlanDeductibleConfigDto>;
    /**
     * 
     * @type {IEnrollmentMatrixLiteDto}
     * @memberof IHealthPlanDto
     */
    enrollment_matrix?: IEnrollmentMatrixLiteDto;
    /**
     * 
     * @type {number}
     * @memberof IHealthPlanDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanDto
     */
    organization_path?: string;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanDto
     */
    summary?: string;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanDto
     */
    notes?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IHealthPlanDto
     */
    are_plans_editable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IHealthPlanDto
     */
    per_person_spend_limit?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IHealthPlanDto
     */
    per_category_spend_limit?: boolean;
    /**
     * 
     * @type {Array<IPlanCategorySpendLimitDto>}
     * @memberof IHealthPlanDto
     */
    category_spend_limits?: Array<IPlanCategorySpendLimitDto>;
    /**
     * 
     * @type {Array<IPlanYearPlanDto>}
     * @memberof IHealthPlanDto
     */
    plans?: Array<IPlanYearPlanDto>;
}

/**
* @export
* @enum {string}
*/
export enum IHealthPlanDtoPlanStatusEnum {
    DRAFT = 'DRAFT',
    ACTIVE = 'ACTIVE',
    UNDER_UPDATE = 'UNDER_UPDATE'
}


/**
 * Check if a given object implements the IHealthPlanDto interface.
 */
export function instanceOfIHealthPlanDto(value: object): value is IHealthPlanDto {
    return true;
}

export function IHealthPlanDtoFromJSON(json: any): IHealthPlanDto {
    return IHealthPlanDtoFromJSONTyped(json, false);
}

export function IHealthPlanDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IHealthPlanDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'parent_id': json['parent_id'] == null ? undefined : json['parent_id'],
        'is_plan': json['is_plan'] == null ? undefined : json['is_plan'],
        'plan_code': json['plan_code'] == null ? undefined : json['plan_code'],
        'name': json['name'] == null ? undefined : INamePropertyDtoFromJSON(json['name']),
        'health_plan_types': json['health_plan_types'] == null ? undefined : IHealthPlanTypePropertyDtoFromJSON(json['health_plan_types']),
        'carrier_id': json['carrier_id'] == null ? undefined : ICarrierIdPropertyDtoFromJSON(json['carrier_id']),
        'plan_status': json['plan_status'] == null ? undefined : json['plan_status'],
        'is_auto_enrollment': json['is_auto_enrollment'] == null ? undefined : IIsAutoEnrollmentPropertyDtoFromJSON(json['is_auto_enrollment']),
        'deductibles_by_service_type': json['deductibles_by_service_type'] == null ? undefined : IDeductiblesByServiceTypePropertyDtoFromJSON(json['deductibles_by_service_type']),
        'plan_year': json['plan_year'] == null ? undefined : IPlanYearLiteDtoFromJSON(json['plan_year']),
        'health_plan_deductible_configs': json['health_plan_deductible_configs'] == null ? undefined : (new Set((json['health_plan_deductible_configs'] as Array<any>).map(IHealthPlanDeductibleConfigDtoFromJSON))),
        'enrollment_matrix': json['enrollment_matrix'] == null ? undefined : IEnrollmentMatrixLiteDtoFromJSON(json['enrollment_matrix']),
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'summary': json['summary'] == null ? undefined : json['summary'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'are_plans_editable': json['are_plans_editable'] == null ? undefined : json['are_plans_editable'],
        'per_person_spend_limit': json['per_person_spend_limit'] == null ? undefined : json['per_person_spend_limit'],
        'per_category_spend_limit': json['per_category_spend_limit'] == null ? undefined : json['per_category_spend_limit'],
        'category_spend_limits': json['category_spend_limits'] == null ? undefined : ((json['category_spend_limits'] as Array<any>).map(IPlanCategorySpendLimitDtoFromJSON)),
        'plans': json['plans'] == null ? undefined : ((json['plans'] as Array<any>).map(IPlanYearPlanDtoFromJSON)),
    };
}

export function IHealthPlanDtoToJSON(json: any): IHealthPlanDto {
    return IHealthPlanDtoToJSONTyped(json, false);
}

export function IHealthPlanDtoToJSONTyped(value?: IHealthPlanDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'parent_id': value['parent_id'],
        'is_plan': value['is_plan'],
        'plan_code': value['plan_code'],
        'name': INamePropertyDtoToJSON(value['name']),
        'health_plan_types': IHealthPlanTypePropertyDtoToJSON(value['health_plan_types']),
        'carrier_id': ICarrierIdPropertyDtoToJSON(value['carrier_id']),
        'plan_status': value['plan_status'],
        'is_auto_enrollment': IIsAutoEnrollmentPropertyDtoToJSON(value['is_auto_enrollment']),
        'deductibles_by_service_type': IDeductiblesByServiceTypePropertyDtoToJSON(value['deductibles_by_service_type']),
        'plan_year': IPlanYearLiteDtoToJSON(value['plan_year']),
        'health_plan_deductible_configs': value['health_plan_deductible_configs'] == null ? undefined : (Array.from(value['health_plan_deductible_configs'] as Set<any>).map(IHealthPlanDeductibleConfigDtoToJSON)),
        'enrollment_matrix': IEnrollmentMatrixLiteDtoToJSON(value['enrollment_matrix']),
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'summary': value['summary'],
        'notes': value['notes'],
        'are_plans_editable': value['are_plans_editable'],
        'per_person_spend_limit': value['per_person_spend_limit'],
        'per_category_spend_limit': value['per_category_spend_limit'],
        'category_spend_limits': value['category_spend_limits'] == null ? undefined : ((value['category_spend_limits'] as Array<any>).map(IPlanCategorySpendLimitDtoToJSON)),
        'plans': value['plans'] == null ? undefined : ((value['plans'] as Array<any>).map(IPlanYearPlanDtoToJSON)),
    };
}

